module.exports = __webpack_public_path__ + "img/0-md.c1b98a5f.jpg";